import { useMutation } from '@tanstack/react-query';

import { Api } from '@/shared/api';
import { useCurrentProject } from '@/shared/projects/project-path';

export function useUpdatePublisherMutation() {
  const project = useCurrentProject();
  return useMutation({
    mutationFn: (data: Parameters<typeof Api.publishers.updatePublisher>[1]) =>
      Api.publishers.updatePublisher(project, data),
  });
}

export function useUploadPublisherPreviewMutation() {
  const project = useCurrentProject();
  return useMutation({
    mutationFn: (
      file: Parameters<typeof Api.publishers.uploadPublisherPreview>[1],
    ) => Api.publishers.uploadPublisherPreview(project, file),
  });
}
